angular.module('dpw.services')

    .factory('SimpleField', ['SimpleForm', function (SimpleForm) {
        /**
         * SimpleField Class
         *
         * @param {SimpleForm}   form                           - The form which this field locates in, and it must be an instance of `SimpleForm`
         * @param {Object}       options                        - Configurations for the field
         * @param {String}       options.name                   - Name for the field
         * @param {String}       [options.initialValue]         - Initial value for the field
         * @param {Function}     [options.onChange]             - Invoked on text change
         * @param {Function}     [options.onFocus]              - Invoked when the field is focused
         * @param {Object|Array} [options.validation]           - Validations for the field
         *        {Function}     [options.validation].validator - Should take the value as parameter, and return a boolean
         *        {String}       [options.validation].errorCode
         * @param {Object}       [options.messages]             - Messages for errors
         * @constructor
         */
        function SimpleField(form, options) {
            this.form = form;
            options = options || {};

            if (!(this.form instanceof SimpleForm)) {
                throw Error('The first parameter `form` must be an instance of `SimpleForm`');
            }

            // Basics
            this.name = options.name;
            this.value = options.initialValue || '';

            // Events
            options.onChange && (this.onChange = options.onChange);
            options.onFocus && (this.onFocus = options.onFocus);

            // Validation
            this.validation = options.validation;
            this.errors = [];
            this.messages = options.messages || {};
        }

        /**
         * Default behavior when the field is changed
         */
        SimpleField.prototype.onChange = function () {
            var self = this;

            var validation = this.validation;
            if (validation) {
                _.isPlainObject(validation) && validate(validation);
                _.isArray(validation) && _.forEach(validation, validate);
            }

            function validate(config) {
                // The situation when the field value is empty is handled by other form validation mechanism.
                var isValid = _.isEmpty(self.value) ? true : config.validator(self.value);

                isValid ? self.removeError(config.errorCode) : self.addError(config.errorCode);
            }
        };

        /**
         * Default behavior when the field is focused
         */
        SimpleField.prototype.onFocus = function () {
            this.form.setFieldStatus(this.name, '$setUntouched');
        };

        /**
         * Mark the field as invalid, and clear the flag on next change
         *
         * @param {String} code
         */
        SimpleField.prototype.markAsInvalid = function (code) {
            var self = this;

            addFlag();
            clearFlagOnNextChange();

            function addFlag() {
                self.addError(code);
            }

            function clearFlagOnNextChange() {
                var onChangeFn = self.onChange;

                self.onChange = function () {
                    self.removeError(code);
                    self.onChange = onChangeFn;
                    self.onChange();
                };
            }
        };

        /**
         * Get controller for the field provided by AngularJS
         *
         * @returns {Object} - Angular field controller
         */
        SimpleField.prototype.getFieldCtrl = function () {
            return _.get(this.form.getFormCtrl(), this.name);
        };

        /**
         * Add an error to the field
         *
         * @param {String} code
         */
        SimpleField.prototype.addError = function (code) {
            this.form.setFieldStatus(this.name, '$setValidity', [code, false]);
            !_.include(this.errors, code) && this.errors.push(code);
        };

        /**
         * Remove an error from the field
         *
         * @param {String} code
         */
        SimpleField.prototype.removeError = function (code) {
            this.form.setFieldStatus(this.name, '$setValidity', [code, true]);
            _.remove(this.errors, function (existingCode) {
                return existingCode === code;
            });
        };

        return SimpleField;
    }])

;